module.exports = __webpack_public_path__ + "static/img/ic_no_access.e185ac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/appBackend/assets/ic_no_access.png
// module id = 1114
// module chunks = 2